/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Toolbar_LabelInputs */

const en_explorer_info_toolbar_label = /** @type {(inputs: Explorer_Info_Toolbar_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolbar with button groups`)
};

const fr_explorer_info_toolbar_label = /** @type {(inputs: Explorer_Info_Toolbar_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barre d'outils avec groupes de boutons`)
};

const de_explorer_info_toolbar_label = /** @type {(inputs: Explorer_Info_Toolbar_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Symbolleiste mit Schaltflächengruppen`)
};

const it_explorer_info_toolbar_label = /** @type {(inputs: Explorer_Info_Toolbar_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barra degli strumenti con gruppi di pulsanti`)
};

const ru_explorer_info_toolbar_label = /** @type {(inputs: Explorer_Info_Toolbar_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Панель инструментов с группами кнопок`)
};

const es_explorer_info_toolbar_label = /** @type {(inputs: Explorer_Info_Toolbar_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barra de herramientas con grupos de botones`)
};

const zh_cn2_explorer_info_toolbar_label = /** @type {(inputs: Explorer_Info_Toolbar_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`带有按钮组的工具栏`)
};

const ja_explorer_info_toolbar_label = /** @type {(inputs: Explorer_Info_Toolbar_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ボタングループ付きのツールバー`)
};

const hi_explorer_info_toolbar_label = /** @type {(inputs: Explorer_Info_Toolbar_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बटन समूहों के साथ टूलबार`)
};

const pt_pt2_explorer_info_toolbar_label = /** @type {(inputs: Explorer_Info_Toolbar_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barra de ferramentas com grupos de botões`)
};

/**
* | output |
* | --- |
* | "Toolbar with button groups" |
*
* @param {Explorer_Info_Toolbar_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_toolbar_label = /** @type {((inputs?: Explorer_Info_Toolbar_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Toolbar_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_toolbar_label(inputs)
	if (locale === "de") return de_explorer_info_toolbar_label(inputs)
	if (locale === "it") return it_explorer_info_toolbar_label(inputs)
	if (locale === "ru") return ru_explorer_info_toolbar_label(inputs)
	if (locale === "es") return es_explorer_info_toolbar_label(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_toolbar_label(inputs)
	if (locale === "ja") return ja_explorer_info_toolbar_label(inputs)
	if (locale === "hi") return hi_explorer_info_toolbar_label(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_toolbar_label(inputs)
	return en_explorer_info_toolbar_label(inputs)
});